module.exports = __webpack_public_path__ + "img/bin.96c2bac7.png";